import * as React from 'react';

export interface LightPanelProps {
  title: string;
  subtitle?: string;
  image_url: string;
  className?: string;
  children?: any;
  size?: any;
}

const captionClasses = `
  absolute pa1 pa2-ns pa4-ns bottom-0 left-0 right-0 z-2 tc ml-auto mr-auto w-80-l`;

const largeSizeToClass = (input = '50') => `w-${input}-l`;

const panelClasses = (props: LightPanelProps) =>
  `fl w-100
  ${largeSizeToClass(props.size)}
  pr1-ns pr2-l pb3 pb2-l
  ${props.className}`;

export const Caption = ({ children }: any) => (
  <figcaption className={captionClasses}>{children}</figcaption>
);

export const LightPanel = (props: LightPanelProps) => (
  <div className={panelClasses(props)}>
    <div className="aspect-ratio aspect-ratio--1x1 bg-ui-white-0">
      <div
        className="aspect-ratio--object cover z-1"
        style={{
          backgroundImage: `url(${props.image_url})`,
          backgroundSize: '80%',
        }}
      />
      <Caption>
        <h3 className="f3 f2-ns lh-title ma0 mb3">{props.title}</h3>
        {props.subtitle && (
          <p className="lh-copy ttu f6 fw5 black-70">{props.subtitle}</p>
        )}
      </Caption>
    </div>
  </div>
);

export default LightPanel;
